export enum EsAccountStatus {
  Error = 'Error',
  /** Created and managed through the api */
  Managed = 'Managed',
  Pending = 'Pending',
  /** Created by the client */
  Shared = 'Shared',
}
